/* eslint-disable react-hooks/rules-of-hooks */
import { Card, Form } from '@deere/ux.uxframe-react';
import { useTranslation } from "react-i18next";
import { SCBM_CODE } from '../../utils/surveyLiterals';
import { getGroupTierArray } from '../../utils/utils'
import { getTranslation, getAnswerLabel } from '../../utils/utils'


export default function Tier2ReviewSection({ sectionSurvey, answers }) {
    const { t } = useTranslation();
    if (!sectionSurvey)
        return <></>

    const tierForms = answers.filter(answer => answer.tierIndex > 0)
    const questions = sectionSurvey.questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    const tierContacts = getGroupTierArray(tierForms, questions, false , SCBM_CODE);
    const questionNoTier = questions[6];//Question for no tier provide
    const answerNoTier = !tierContacts || tierContacts.length <= 0?getAnswerLabel(questionNoTier,answers):null;
    
    return (<div>
        <Card>
            <Card.Body>
                <Card.Title className='pb-3'>
                    {getTranslation(sectionSurvey, 'description')} <small style={{ color: 'gray' }}>{t('t2_subtitle')} </small>
                </Card.Title>
                {
                    tierContacts && tierContacts.length > 0? tierContacts.map((con, idx) =>{
                        let answerOrdered = con.sort((a, b) => (a.questionId > b.questionId) ? 1 : -1)
                        return <div key={idx}>
                            <Form.Row>
                                <Form.Label>{answerOrdered[0].answer}</Form.Label>
                            </Form.Row>
                            <Form.Row>
                                <Form.Label>{con[2].answer + ', '}
                                    {answerOrdered[3].answer + ', '}
                                    {answerOrdered[5].answer + ' '}
                                    {answerOrdered[4].answer + ', '}
                                    {answerOrdered[1].answer}
                                </Form.Label>
                            </Form.Row>
                        </div>}) : <></>
                }
                {
                   !tierContacts || tierContacts.length <= 0?<><Form.Row>
                                                                <Form.Label>{t('lbl_ph_t2_reason_header')}</Form.Label>
                                                                </Form.Row>
                                                                <Form.Row><Form.Label>{answerNoTier}</Form.Label></Form.Row></>:<></>
                }
            </Card.Body>
        </Card>
    </div>)
}